export default __webpack_public_path__ + "static/media/comunication_bg_large.9b0d0cb3.svg";